import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute, useRouter } from '@tanstack/react-router';
import { useAuth } from '../../../features/auth/auth-context';
import { listCitiesOptions } from '../../../features/cities/queries';
import { DeleteMeetingTemplateDialog } from '../../../features/meeting-templates/components/delete-meeting-template-dialog';
import { MeetingTemplateForm } from '../../../features/meeting-templates/components/meeting-template-form';
import { meetingTemplateByIdOptions } from '../../../features/meeting-templates/queries';
import { PageHeader } from '../../../shared/components/page-header';

export const Route = createFileRoute('/_authenticated/meeting-templates/$templateId')({
  staticData: { breadcrumb: 'Редактирование' },
  loader: ({ context, params }) =>
    Promise.all([
      context.queryClient.ensureQueryData(meetingTemplateByIdOptions(params.templateId)),
      context.queryClient.ensureQueryData(listCitiesOptions()),
    ]),
  component: EditMeetingTemplatePage,
});

function EditMeetingTemplatePage() {
  const router = useRouter();
  const { templateId } = Route.useParams();
  const { data: template } = useSuspenseQuery(meetingTemplateByIdOptions(templateId));
  const { data: cities } = useSuspenseQuery(listCitiesOptions());
  const { adminRoles } = useAuth();
  const isSuperadmin = adminRoles.includes('SUPERADMIN');

  return (
    <div>
      <PageHeader
        title={`${template.emoji} ${template.title}`}
        description={`slug: ${template.slug}`}
        actions={
          isSuperadmin ? (
            <DeleteMeetingTemplateDialog
              template={template}
              onDeleted={() => router.navigate({ to: '/meeting-templates' })}
            />
          ) : null
        }
      />
      <MeetingTemplateForm mode="edit" template={template} cities={cities} />
    </div>
  );
}
